import type { HotelRoomOption, SortedRate } from '../types/hotels.presentation';
import type { RatePolicyMode } from '../hooks/useHotelBooking';

/**
 * Optionally hides rates that still have no availability quote.
 * Rates with disposition `unavailable` (blocked / missing policy) stay visible
 * so the UI can offer the same Consultar flow as non-refundable.
 */
export function filterRoomOptionsByPolicy(
  roomOptions: HotelRoomOption[],
  ratePolicyModes: Record<string, RatePolicyMode>,
  options?: { hideUntilQuoted?: boolean },
): HotelRoomOption[] {
  const hideUntilQuoted = options?.hideUntilQuoted ?? false;

  const filtered: HotelRoomOption[] = [];

  for (const option of roomOptions) {
    const rates = option.rates.filter((rate) =>
      isRateVisible(rate, ratePolicyModes, hideUntilQuoted),
    );
    if (rates.length === 0) continue;

    const best = rates[0];
    filtered.push({
      ...option,
      rates,
      bestRateKey: best.key,
      board: best.meal || best.board,
      refundable: best.refundable,
      cancellation: best.cancellation,
      net: best.net,
      sale: best.sale,
      rateCount: rates.length,
    });
  }

  return filtered;
}

function isRateVisible(
  rate: SortedRate,
  ratePolicyModes: Record<string, RatePolicyMode>,
  hideUntilQuoted: boolean,
): boolean {
  const mode = ratePolicyModes[rate.key];
  if (hideUntilQuoted && mode == null) return false;
  return true;
}
